import DialogContent from "@mui/material/DialogContent";
import { DialogActions, TextField, FormHelperText, Grid, Button } from "@mui/material";
import { DialogTitle } from "@mui/material";
import DialogContentText from "@mui/material/DialogContentText";

////////////////
// COMPONENTS //
////////////////

///////////////////
// warning message //
///////////////////

export interface IModalWarninigTextProps {
  warning: string;
}
export const ModalWarningText = (props: IModalWarninigTextProps): JSX.Element => {
  return <FormHelperText className={"warning"}>{props.warning}</FormHelperText>;
};

///////////////////
// error message //
///////////////////

export interface IModalErrorTextProps {
  error: string;
}
export const ModalErrorText = (props: IModalErrorTextProps): JSX.Element => {
  return <FormHelperText className={"error"}>{props.error}</FormHelperText>;
};

///////////
// Title //
///////////
export interface IModalTitleProps {
  title: string;
}

export const ModalTitle = (props: IModalTitleProps): JSX.Element => {
  return (
    <DialogTitle id="alert-dialog-title" className={"title"}>
      {props.title}
    </DialogTitle>
  );
};

/////////////
// Message //
/////////////

export interface IModalMessageProps {
  message: string | JSX.Element;
}

export const ModalMessage = (props: IModalMessageProps): JSX.Element => {
  return (
    <DialogContentText id="alert-dialog-description" className={"message"}>
      {props.message}
    </DialogContentText>
  );
};

/////////////
// LIST //
/////////////

export interface IModalListProps {
  descrption: string;
  list: string[];
}

export const ModalList = (props: IModalListProps): JSX.Element => {
  const { descrption, list } = props;
  return (
    <Grid container className="modal_list">
      <Grid item className="description">
        {descrption}
      </Grid>
      <Grid container className="list_container">
        {list.map((each, index) => (
          <Grid
            item
            xs={12}
            key={`item-${index}`}
            className="list_item"
            sx={{
              paddingTop: "4px",
              paddingBottom: "4px",
            }}
          >
            {each}
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
};

////////////
// Button //
////////////

export interface IModalButtonProps {
  label: string;
  handler: any;
  disable?: boolean;
}

export const ModalButton = (props: IModalButtonProps): JSX.Element => {
  return (
    <DialogActions>
      <Button
        id={props.label + "_btn"}
        key={props.label}
        disabled={props.disable || false}
        onClick={props.handler}
        color="primary"
        autoFocus={true}
      >
        {props.label}
      </Button>
    </DialogActions>
  );
};

/////////////////
// Native Form //
/////////////////

export interface IModalNativeFormProps {
  data: string[];
  onChange: any;
  placeholder: string;
  value: string;
}

export const ModalNativeForm = (props: IModalNativeFormProps): JSX.Element => {
  return (
    <DialogContent>
      <form className={"nativeForm"} noValidate autoComplete="off">
        <TextField
          id="standard-select-native"
          select
          value={props.value}
          onChange={props.onChange}
          SelectProps={{
            native: true,
            MenuProps: {
              className: "menu",
            },
          }}
          margin="dense"
          fullWidth={true}
        >
          <option key="0" value="0">
            {props.placeholder}
          </option>
          {props.data.map((option: any) => (
            <option key={option} value={option}>
              {option}
            </option>
          ))}
        </TextField>
      </form>
    </DialogContent>
  );
};
